import React from 'react';
import { RichTextAdvancedRender } from '../../../../../inputs';
import { ConfigFormItem } from '../../../../../ui/form/ConfigFormItem';
import { DivInputStyle } from '../../../../../ui/form/DivInputStyle';
import { ComputeExpressionPreview } from '../../../../expressions/compute/preview/ComputeExpressionPreview';
import { IWidgetComponentProps } from '../../../IWidgetType';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps';
import { ISwitchWidget } from './ISwitchWidget';

export interface IScoreWidgetPreviewComponentProps
  extends IWidgetComponentProps<ISwitchWidget> {}

export function ScoreWidgetPreviewComponent(
  props: IScoreWidgetPreviewComponentProps,
) {
  const { widget } = props;

  const options = getWidgetProps(props);

  return (
    <ConfigFormItem
      name="string"
      label={<RichTextAdvancedRender inline text={options.label} />}
      help={<RichTextAdvancedRender inline text={options.helpText} />}
      layout={{ hideVisualLabel: options.hideLabel }}
      readonly={options.readonly}
    >
      <DivInputStyle>
        <ComputeExpressionPreview expression={{ raw: '', value: [] }} />
      </DivInputStyle>
    </ConfigFormItem>
  );
}
